import ApiService from "@/core/services/api.service";

export default {
  select(query = {}) {
    return ApiService.query('client/vehicles', query)
  }
}
